import React, { useState } from 'react'
import dynamic from 'next/dynamic'

// import { UnControlled as CodeMirror } from 'react-codemirror2'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material.css'

dynamic(() => import('codemirror/mode/javascript/javascript'), { ssr: false })
dynamic(() => import('codemirror/mode/xml/xml'), { ssr: false })
dynamic(() => import('codemirror/mode/htmlmixed/htmlmixed'), { ssr: false })

dynamic(() => import('codemirror/addon/edit/closebrackets'), { ssr: false })
dynamic(() => import('codemirror/addon/edit/closetag'), { ssr: false })

const CodeMirror = dynamic(() => import('react-codemirror2').then((module) => module.UnControlled))

const CodeEditor = ({ value, onChange }) => {
  return (
    CodeMirror && (
      <div className="code-editor">
        <CodeMirror
          className="code-editor"
          value={value}
          autoCursor={false}
          options={{
            mode: 'xml',
            theme: 'material',
            lineNumbers: true,
            lineWrapping: true,
            autoCloseBrackets: true,
            autoCloseTags: true,
          }}
          onChange={(editor, data, value) => {
            onChange(value)
          }}
        />
      </div>
    )
  )
}

export default CodeEditor
